import { render, staticRenderFns } from "./PDatePicker.vue?vue&type=template&id=6f89ca77&"
import script from "./PDatePicker.vue?vue&type=script&lang=js&"
export * from "./PDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports